import { Form } from "antd"
import dayjs from "dayjs"
import TimeRangeSelector from "components/common/timeRangePicker/timeRangePicker"
import { DatePicker, Group } from "components/common"
import { DATE_FORMAT } from "constants"

const mergeRules = (...ruleSets) => ruleSets.filter(Array.isArray).flat().filter(Boolean)

const DateTimePicker = ({
  grouped = false,
  fieldNames = [],
  fieldLabels = [],
  required = false,
  rules = [],
  hidden = false,
  isRangePicker = false,
  datePickerProps = {},
  timePickerProps = {},
  dateRules = [],
  timeRules = [],
  disabled = false,
  range = { startDate: dayjs() },
  dateFormat = DATE_FORMAT,
  dateExtra,
  timeExtra,
  startDate
}) => {
  const [dateField, timeField] = fieldNames
  const [dateLabel, timeLabel] = fieldLabels

  const PickerFields = (
    <>
      <Form.Item
        name={dateField}
        label={dateLabel}
        required={required}
        rules={mergeRules(rules, dateRules)}
        hidden={hidden}
        extra={dateExtra}
      >
        <DatePicker
          format={dateFormat}
          showTime={false}
          disabled={disabled}
          getPopupContainer={trigger => trigger.parentNode}
          range={range}
          {...datePickerProps}
        />
      </Form.Item>

      <Form.Item noStyle shouldUpdate={(prev, curr) => prev[dateField] !== curr[dateField]}>
        {({ getFieldValue }) => {
          const selectedDate = getFieldValue(dateField) || dayjs()
          return (
            <Form.Item
              name={timeField}
              label={timeLabel}
              required={required}
              rules={mergeRules(rules, timeRules)}
              hidden={hidden}
              extra={timeExtra}
            >
              <TimeRangeSelector
                isRangePicker={isRangePicker}
                disabled={disabled}
                startDate={startDate || selectedDate}
                {...timePickerProps}
              />
            </Form.Item>
          )
        }}
      </Form.Item>
    </>
  )

  // If grouped → wrap both under Group
  if (grouped) {
    return (
      <Group template="repeat(2, 2fr)" gap="4px 32px">
        {PickerFields}
      </Group>
    )
  }
  // Else → render separate Form.Items directly
  return PickerFields
}

export default DateTimePicker
